import React, { useState } from "react";
import ReusableTable from "../../../../../components/PagesComponents/Financial/CashOutFlow/Charity/Reusable.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import DetailsView from "../../../../../components/PagesComponents/Financial/CashOutFlow/Charity/DetailsView.component";

const Body = ({
  educationalColumn,
  educationalDonation,
  coordinators = [],
  verifiers = [],
}) => {
  const [model, openModel] = useState(false);
  const onClose = () => {
    openModel(false);
  };
  return (
    <div
      style={{ display: "flex", margin: "1rem", gap: "1rem" }}
      className="EducationalMaterialContainer"
    >
      <ScrollableModal isOpen={model} onClose={onClose}>
        <DetailsView
          onClose={onClose}
          highlightKey="donationId"
          data={{
            "Donation id": "2398476282",
            "Scheme name": "Siksha vikash",
            "Org/NGO name": "Dristi social welfare committee",
            Contact: "9876543210",
            "Additional cost (INR)": "₹ 23,45",
            "Total eqvt. cost (INR)": "₹ 25,498",
            Coordinator: "Rafik Haldar",
            "Verified by": "Javed Habib",
          }}
          description="Inspection is near about two hours within a campus. Mainly school building. It touches a world class standard."
        />
      </ScrollableModal>
      <div
        style={{ background: "white", padding: "1rem", borderRadius: "10px" }}
        className="formContaienr"
      >
        <h2
          style={{
            color: "var(--grayColor)",
            fontWeight: "400",
            borderBottom: "1px solid var(--borderGray)",
            paddingBottom: "1rem",
          }}
          className="form-title"
        >
          Add other charity into the list
        </h2>
        <div>
          <Formik
            initialValues={{
              schemeName: "",
              description: "",
              organization: "",
              contact: "",
              item: "Books",
              quantity: 250,
              pricePerUnit: 1200,
              additionalCost: "",
              coordinator: "",
              verifier: "",
            }}
            onSubmit={(values) => {
              console.log("Submitted:", values);
              openModel(true);
            }}
          >
            {({
              values,
              setFieldValue,
              handleSubmit,
              touched,
              errors,
              setTouched,
            }) => {
              const totalPrice =
                (parseFloat(values.quantity) || 0) *
                  (parseFloat(values.pricePerUnit) || 0) +
                (parseFloat(values.additionalCost) || 0);

              return (
                <form onSubmit={handleSubmit} className="p-1">
                  <div className="grid grid-cols-2 gap-4 mb-05">
                    <FormInput
                      label="Scheme name"
                      type="text"
                      name="schemeName"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter the schema name"
                      setFieldValue={(e) =>
                        setFieldValue("schemeName", e.target.value)
                      }
                    />

                    <FormInput
                      label="Description"
                      type="text"
                      name="description"
                      touched={touched}
                      errors={errors}
                      placeholder="Type something here"
                      setFieldValue={(e) =>
                        setFieldValue("description", e.target.value)
                      }
                    />
                    <FormInput
                      label="Org/NGO name (if any)"
                      type="text"
                      name="organization"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter organization/NGO name"
                      setFieldValue={(e) =>
                        setFieldValue("organization", e.target.value)
                      }
                    />

                    <FormInput
                      label="Contact (if any)"
                      type="text"
                      name="contact"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter phone number"
                      setFieldValue={(e) =>
                        setFieldValue("contact", e.target.value)
                      }
                    />
                  </div>

                  <hr />

                  <h3 className="text-lg font-semibold mt-05">Material cost</h3>
                  <div className="grid grid-cols-3 gap-4">
                    <FormInput
                      label="Item"
                      type="text"
                      name="item"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter item Name"
                      setFieldValue={(e) =>
                        setFieldValue("item", e.target.value)
                      }
                    />
                    <FormInput
                      label="Quantity"
                      type="number"
                      name="quantity"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter item quantity"
                      setFieldValue={(e) =>
                        setFieldValue("quantity", e.target.value)
                      }
                    />

                    <FormInput
                      label="Eqvt. price (INR)"
                      type="number"
                      name="pricePerUnit"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter item pricePerUnit"
                      setFieldValue={(e) =>
                        setFieldValue("pricePerUnit", e.target.value)
                      }
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-4 mt-1">
                    <FormInput
                      label="Additional cost (INR)"
                      type="number"
                      name="additionalCost"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter item additionalCost"
                      setFieldValue={(e) =>
                        setFieldValue("additionalCost", e.target.value)
                      }
                    />
                    <div className="modalFormInputContainer">
                      <label htmlFor="total">
                        Total equivalent price (INR)
                      </label>
                      <input
                        style={{ height: "48px" }}
                        name="total"
                        type="text"
                        className="textareaClass"
                        value={totalPrice}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <DropDownInput
                      name="coordinator"
                      label="Coordinator"
                      value={values.coordinator}
                      placeholder="Choose a coordinator"
                      suggestionList={coordinators}
                      setFieldValue={(val) => setFieldValue("coordinator", val)}
                    />
                    <DropDownInput
                      name="verifier"
                      label="Verifier"
                      value={values.verifier}
                      placeholder="Choose payment verifier"
                      suggestionList={verifiers}
                      setFieldValue={(val) => setFieldValue("verifier", val)}
                    />
                  </div>

                  <button type="submit" className="actionBtn w-full mt-1">
                    Confirm
                  </button>
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
      <ReusableTable
        title="Other charity list"
        countLabel={`${educationalDonation.length} times`}
        columns={educationalColumn}
        data={educationalDonation}
        renderedElement={
          <div
            style={{ marginLeft: "auto", marginTop: "1rem" }}
            className="lightBlueInfoBox"
          >
            <span className="info-title">
              Total Educational material donation amount:
            </span>{" "}
            ₹ 2,60,560
          </div>
        }
        gridColumnStyle="1fr 1fr 1fr"
      />
    </div>
  );
};

export default Body;
